import React from 'react'
import Results from '../QuizResults/Results'
import { useQuiz } from '../QuizProvider'
import useTranslation from '../../shared/TranslationProvider'
import { useIsDesktop } from '../../../hooks/useMediaQuery'
import Avatar from '../Avatar'
import { usePointsQuizScore } from '~/components/JobSearchQuiz/useScoreCalculator'

const OnboardingReadinessResults = () => {
  const { t } = useTranslation('onboarding_readiness')
  const { trackContent, resultsPageAvatar } = useQuiz()

  const breakPoints = [7, 5]

  const [scoreSection, score] = usePointsQuizScore(
    trackContent,
    t('questions'),
    breakPoints,
  )

  const copy = t(`results.${scoreSection}.copy`)

  const isDesktop = useIsDesktop()

  return (
    <Results>
      <div className="mb-8 flex pb-6 sm:justify-around">
        <div className="mt-1 flex h-96 flex-col gap-4 sm:w-9/12">
          <h2>{t(`results.score`, { score })}</h2>
          <div className="mt-4">
            {copy.map((par, idx) => (
              <p key={`results-page-${idx}`}>{par}</p>
            ))}
          </div>
        </div>
        {isDesktop && <Avatar src={resultsPageAvatar} />}
      </div>
    </Results>
  )
}

export default OnboardingReadinessResults
